export const faqEntryEnum: Record<number, string> = {
  360014300618: 'hc/en-gb/articles/360014300618',
};
